import { z } from "zod";
import { DTOIntegrationsGetListResponse } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class WorkspaceIntegrationsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(wsId: string) {
    return this.requestExecutor.json(`/workspaces/${wsId}/integrations`, DTOIntegrationsGetListResponse);
  }

  delete(wsId: string, iId: string) {
    return this.requestExecutor.json(`/workspaces/${wsId}/integrations/${iId}`, z.unknown(), { method: "DELETE" });
  }
}
